module.exports = __webpack_public_path__ + "static/media/ericjulius.eb487559.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ericjulius.png
// module id = 253
// module chunks = 0